module.exports = __webpack_public_path__ + "img/music.8f52369f.png";